import { render, staticRenderFns } from "./BeneficiaryAccount.vue?vue&type=template&id=42d3ec54"
import script from "./BeneficiaryAccount.vue?vue&type=script&lang=js"
export * from "./BeneficiaryAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports